import React, { ReactNode } from 'react';
import { Box, Modal } from '@mui/joy'; // Use Box for layout
import { withSafeBottom } from '@mono-farmart-web/ui-components/component/UnifiedHeader/safeArea';

interface BottomSheetProps {
	children?: ReactNode;
	testId?: string;
	toggled: boolean;
	onToggled: () => void;
}

const BottomSheet: React.FC<BottomSheetProps> = ({
	testId,
	toggled,
	onToggled,
	children,
}) => {
	return (
		<>
			<Modal
				open={toggled}
				onClose={onToggled}
				sx={{
					backgroundColor: 'rgba(0, 0, 0, 0.2)',
					display: 'flex',
					alignItems: 'flex-end',
					justifyContent: 'center',
				}}
				data-testid={`${testId}-modal`}
			>
				<Box
					sx={{
						width: '100%',
						backgroundColor: 'neutral.50', // Ensure solid background
						p: 4,
						paddingBottom: withSafeBottom('16px'),
						borderTopLeftRadius: 12,
						borderTopRightRadius: 12,
						position: 'fixed',
						bottom: 0,
						left: '50%',
						transform: 'translateX(-50%)', // Center the box horizontally
						maxHeight: '80vh', // Prevents it from going off-screen
						overflowY: 'auto', // Enables scrolling if content overflows
						boxSizing: 'border-box',
					}}
					data-testid={`${testId}-modal-box`}
				>
					{children}
				</Box>
			</Modal>
		</>
	);
};

export default React.memo(BottomSheet);
